import {minValue, required, numeric} from "vuelidate/lib/validators";
import {ModelObject} from "@/pages/Common/modelObject";

export const RequestStatus = Object.freeze({
    OPEN: 1,
    ASSIGNED: 2,
    WIP: 3,
    DONE: 5,
    CLOSED: 4,
    CANCELLED: 6
});


export class Request extends ModelObject {
        constructor(initObjectParams) {
            super(initObjectParams);

            this.id = null;
            this.status = RequestStatus.OPEN;
            this.description = null;
            this.animalsCount = null;
            this.animalSpecies = null;
            this.applicant = null;
            this.applicantPhone = null;
            this.address = null;
            this.activity = null;
            this.result = null;
            this.refuseReason = null;
            this.contract = null;
            this.lat = null;
            this.lon = null;

            this.addressObject = {};
            this.activityObject = {};
            this.contractObject = {};
            this.descriptionObject = {};
            this.animalSpeciesObject = {};

            this.createdAt = null;
            this.caughtCount = 0;
            this.isArchived = false;
            this.archiveDate = null;

            this.animalsToRelease = [];
            this.animalObjectsToRelease = [];
            this.animalsAvailableToRelease = [];

            this.isFromNavigator = false

            this.applyInitObjectParams(initObjectParams);

        }

        static get modelName() {
            return 'Request'
        }

        get modelName() {
            return 'Request'
        }

        static get baseValidations() {
            return {
                status: { required },
                description: {  },
                animalSpecies: {  },
                applicant: {  },
                applicantPhone: {  },
                address: { required },
                activity: { required },
                contract: {},
                result: {},
                refuseReason: {},
                animalsToRelease: {},
                lat: {},
                lon: {}
            }
        }

        static get validations() {
            return {...this.baseValidations, ...{ animalsCount: {  }} }
        }

        static get catchingValidations() {
            return {...this.baseValidations, ...{animalsCount: { required, minValue: minValue(1) }}}
        }

        static get validationFieldLabels() {
            return {
                status: 'Статус',
                description: 'Описание',
                animalsCount: 'К отлову',
                animalSpecies: 'Вид животного',
                applicant: 'Заявитель',
                applicantPhone: 'Телефон заявителя',
                address: 'Адрес',
                activity: 'Тип',
                contract: 'Исполнитель',
                result: 'Результат',
                refuseReason: 'Причина отказа',
                animalsToRelease: 'Животные на выпуск'
            }
        }

        static get mapping() {
            return {
                animalSpecies: 'animal_species',
                animalsCount: 'animals_count',
                applicantPhone: 'applicant_phone',
                animalRegNumber: 'animal_reg_number',
                animalsToRelease: 'animals_to_release',
                refuseReason: 'refuse_reason'
            }
        }

        static get label() {
            return 'Заявка'
        }

        label() {
            return 'Заявка'
        }

        static get newLabel() {
            return 'Новая заявка'
        }

        objectLabel() {
            return `${Request.label} №${this.id} на ${this.activityName.toLowerCase()}`
        }

        get coordinates() {
            return { lat: this.lat, lon: this.lon }
        }

        get statusName() {
            return this.id && this.descriptionObject ? this.descriptionObject['status_name'] : null
        }

        get activityName() {
            return this.id && this.descriptionObject ? this.descriptionObject['activity_name'] : null
        }

        get createdAtDate() {
            return this.id && this.createdAt ? this.createdAt.split(' ')[0] : null
        }

        get createdAtTime() {
            return this.id && this.createdAt ? this.createdAt.split(' ')[1] : null
        }

        get addressHumanReadable() {
            return this.id && this.addressObject ? this.addressObject['short_text'] : null
        }

        get assignedToId() {
            return this.contractObject && this.contractObject['contractor_object'] ? this.contractObject['contractor_object']['id'] : null
        }

        get municipalityObject() {
            return this.addressObject ? this.addressObject['municipality_object'] : null
        }

        get animalSpeciesName() {
            return this.animalSpeciesObject ? this.animalSpeciesObject['name'] : null
        }

        get animalsLeft() {
            return this.animalsCount - this.caughtCount;
        }

        get assignedTo() {
            let assignedTo = null;
            if (this.contractObject) {
                assignedTo = `${this.contractObject['contractor_object']['name']}`;
                if (this.contractObject['valid_until']) {
                    this.assignedTo = this.assignedTo + ` (до ${this.contractObject['valid_until']})`
                } else {
                    this.assignedTo = this.assignedTo + ` (бессрочный)`
                }
            }
            return assignedTo
        }

        applyData(data) {
            super.applyData(data);
            this.status = this.descriptionObject['status']
        }

}